import React from 'react';
import InnerPanel from './InnerPanel';
const ResponsiveInnerPanel = ({ size, children, ...rest }) => {
    const flexProps = size === 'small'
        ? {
            alignItems: { md: 'flex-start', xl: 'center' },
            h: { xl: '18%' },
        }
        : {
            h: { xl: '64%' },
        };
    return (React.createElement(InnerPanel, { w: { md: '33%', xl: '100%' }, ...flexProps, ...rest }, children));
};
export default ResponsiveInnerPanel;
